import type { WorkPackage } from "./agentExecutionContract";

import type { ExecutionProgramRepository } from "./executionProgramState";

export class ExecutionProgramAugmentationService {
  constructor(private readonly programs: ExecutionProgramRepository) {}

  async append(
    programId: string,

    workPackages: readonly WorkPackage[],
  ) {
    const program = await this.programs.get(programId);

    if (!program) {
      throw new Error(`Execution program ${programId} not found.`);
    }

    const existingIds = new Set(
      program.workItems.map((item) => item.workItem.id),
    );

    const additions = workPackages
      .filter((workPackage) => !existingIds.has(workPackage.id))
      .map((workPackage) => ({
        workItem: workPackage,

        state: workPackage.dependencies.length
          ? ("PENDING" as const)
          : ("READY" as const),

        evidence: [],
      }));

    if (!additions.length) {
      return program;
    }

    const updated = {
      ...program,

      updatedAt: new Date().toISOString(),

      workItems: [...program.workItems, ...additions],
    };

    await this.programs.save(updated);

    return updated;
  }
}
